import ClipboardJS from 'clipboard';

import './navigation';
import './header';
import './ajax-add-to-cart';

const copyLink = document.querySelector('.copy-link');
if (copyLink) {
    new ClipboardJS(copyLink);
}
